import { THouseViewState } from ".";

export type OpenShifts = Record<string, never>;

export const OpenShiftsActions = {
  startOpenShifts: ({ sidebarCurrentAction }: THouseViewState) => {
    sidebarCurrentAction.inProgress = "openShifts";
  },
} as const;
